<template>
    <div class="navbar-container py-3">
        <div class="navbar-item" :class="{ 'active-link': isActiveRoute('Dashboard') }" @click="navigate('Dashboard')">
            <v-icon icon="mdi-view-dashboard-variant"></v-icon>
            {{ $t('i18n.dashboard') }}
        </div>
        <div class="navbar-item" :class="{ 'active-link': isActiveRoute('Devices') }" @click="navigate('Devices')">
            <v-icon icon="mdi-tablet-cellphone"></v-icon>
            {{ $t('i18n.devices') }}
        </div>
        <div class="navbar-item" :class="{ 'active-link': isActiveRoute('Forms') || isActiveRoute('CreateForm') || isActiveRoute('EditForm') }"
            @click="navigate('Forms')">
            <v-icon icon="mdi-list-box-outline"></v-icon>
            {{ $t('i18n.forms') }}
        </div>
        <div class="navbar-item" :class="{ 'active-link': isActiveRoute('Administration') }"
            @click="navigate('Administration')">
            <v-icon icon="mdi-cogs"></v-icon>
            {{ $t('i18n.administration') }}
        </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAppStore } from '@/stores/appStore'
import i18n from '@/translations/i18n'

export default defineComponent({
  name: 'MobileMainNavBar',
  setup () {
    const router = useRouter()
    const route = useRoute()

    const availableLocales = computed(() => i18n.global.availableLocales)
    const currentLanguage = computed(() => i18n.global.locale)

    return {
      router,
      route,
      availableLocales,
      currentLanguage
    }
  },
  components: {
  },
  data () {
    return {
      isLanguageGroupOpen: false
    }
  },
  methods: {
    selectLanguage (locale: 'pt' | 'en') {
      i18n.global.locale = locale
    },
    logoff () {
      const appStore = useAppStore()
      appStore.clearSession()
      this.navigate('Login')
    },
    navigate (routeName: string) {
      this.router.push({ name: routeName })
    },
    isActiveRoute (routeName: string) {
      return this.route.name === routeName
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/base.scss";
@import "../../styles/colors.scss";

.navbar-container {

    * {
        // All child elements
        padding: 0.3em 0.8em;
    }

    background-color: $white;
    color: $grey-1;

    display: grid;

    grid-template-columns: repeat(4, 1fr);

    justify-items: center;
    align-items: center;

    box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.12);

    .navbar-item {

        display: grid;
        grid-template-rows: 2;
        align-items: center;
        justify-items: center;
        font-size: 0.8rem;

        cursor: pointer;

        &.active-link {
            color: $black;
            font-weight: bold;
        }
    }
}

@media (min-width: 960px) {
    .navbar-container {
        display: none;
    }
}
</style>
